<template>
  <div class="wrap">
    <div class="game_places">
      <div class="game_scroll">
        <div class="games">
          <div
            v-for="game in showGameList"
            :key="game.id"
            class="page_game"
            :class="{
              page_game_active: game.id === activeGame.id,
              active_text: game.id === activeGame.id,
            }"
            @click="handleChooseGame(game)"
          >
            <!-- 会场 icon -->
            <div class="page_game_icon" :style="{ backgroundImage: `url(${game.icon})` }"></div>
            <!-- 可转游标识 -->
            <div class="page_game_tag" v-if="game.can_lead === 1">可转游</div>
          </div>
        </div>
      </div>
    </div>
    <div class="game_opera">
      <div class="game_left">
        <div class="game_name">{{ activeGame.name }}</div>
      </div>
      <div class="game_link" @click="onGoGameDetail(activeGame)">查看游戏</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'retourGameBanner',
  props: {
    // 游戏列表数据源
    gameList: {
      type: Array,
      default: () => [],
    },
    activeGame: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  mounted() {},
  watch: {},
  computed: {
    showGameList() {
      const sources = this.gameList;
      if (!Array.isArray(sources) || !sources.length) return [];
      const maxCount = 100;
      const activeGameId = this.activeGame.id;
      const currentIdx = sources.findIndex((item) => item.id === activeGameId);
      const res = currentIdx === -1 ? [] : [sources[currentIdx]];
      sources.forEach((item) => {
        if (res.length === maxCount) return;
        if (item.id === activeGameId) return;
        res.push(item);
      });
      return res;
    },
  },
  methods: {
    // 点击选中游戏
    handleChooseGame(game) {
      this.$emit('chooseGame', game);
    },
    // 点击查看游戏
    onGoGameDetail(game) {
      this.$emit('reportPoint', { data_type: 5, expo_id: game.id, expo_name: game.name });
      // 点击跳转下载
      window.open(game.download_url, '_self');
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 165px;
  padding: 10px 14px;
  position: relative;
  margin: 0 auto;
  background-image: url('https://assets.hzwxbz2.cn/sy/hm_act/img/1135_banner_bg.png');
  background-size: 100% 100%;
}
.game_places {
  position: relative;
  min-height: 84px;
  padding: 4px 6px 6px 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
}
.game_scroll {
  overflow-x: auto;
  padding-top: 16px;
}
.games {
  width: 100%;
  display: flex;
  align-items: baseline;
  padding: 6px 12px;
}
.page_game {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
  position: relative;
}
.page_game:first-child {
  margin-right: 6px;
}

.page_game_icon {
  width: 46px;
  height: 46px;
  transition: 0.15s all ease;
  border-radius: 6px;
  flex-shrink: 0;
  background-size: contain;
  filter: drop-shadow(-2px 1px 3px #333);
}
.page_game_tag {
  position: absolute;
  width: 36px;
  height: 13px;
  background: #f30102;
  border-radius: 3px;
  text-align: center;
  font-size: 9px;
  font-family: Source Han Sans CN, Source Han Sans CN-Medium;
  font-weight: 500;
  color: #ffffff;
  line-height: 13px;
  z-index: 2;
  top: -6px;
  right: -2px;
}
.page_game_active {
  opacity: 1;
  .page_game_icon {
    transform: scale(1.26);
    transform-origin: 50% 100%;
    border-radius: 10px;
    background-size: contain;
  }
  .page_game_tag {
    width: 43px;
    height: 15px;
    line-height: 15px;
    font-size: 11px;
    top: -16px;
    right: -12px;
  }
  .page_game_name {
    width: 130%;
    color: #fad923;
  }
}

.page_game_name {
  width: 115%;
  font-size: 12px;
  text-align: center;
}

.game_opera {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  border-radius: 6px;
  margin-top: 6px;
}

.game_left {
  display: flex;
  align-items: center;
}

.game_name {
  font-size: 16px;
  font-size: 18px;
  font-family: Source Han Sans CN, Source Han Sans CN-Medium;
  font-weight: 500;
  text-align: left;
  color: #ffffff;

  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* autoprefixer: ignore next */
  -webkit-box-orient: vertical;
}

.game_link {
  width: 96px;
  height: 36px;
  background: #ffa61b;
  border-radius: 17.5px;
  color: #fff;
  font-size: 15px;
  font-family: Source Han Sans CN, Source Han Sans CN-Medium;
  font-weight: 500;
  text-align: left;
  text-align: center;
  line-height: 36px;
}
</style>
